module.exports = __webpack_public_path__ + "static/media/24UHCHR20.c9691850.jpg";